<ng-container *ngFor="let notification of notifications$ | async; let last = last">
  <fcom-notification
    *ngIf="notification?.text?.label | finLocalization: notification.text.params as notificationText"
    [theme]="notification.theme"
    class="block"
    [ngClass]="{ 'pr-xxsmall-b': !last }"
    [attr.data-test-notification]="notification.type"
  >
    <p [innerHTML]="notificationText | resolveLinks | finSafe: 'html'"></p>
    <p
      *ngIf="notification?.text1?.label | finLocalization as notificationSecondaryText"
      [innerHTML]="notificationSecondaryText | resolveLinks | finSafe: 'html'"
    ></p>
    <a
      *ngIf="notification?.link"
      [finLink]="
        notification.link.url.startsWith('/')
          ? (notification.link.url | resolveLinks)
          : (notification.link.url | finLocalization | resolveLinks)
      "
      [external]="!!notification.link?.external"
      [openInNewTab]="!!notification.link?.openInNewTab"
      [attr.rel]="'noreferrer'"
      class="underline medium-type link-hover nordic-blue-900-text font-body-1 mr-xsmall-t block"
      data-test-notification-link
    >
      <span class="ms-xxsmall-r">{{ notification.link?.text | finLocalization }}</span>
      <fcom-icon *ngIf="notification.link?.external" class="external-link is-xsmall" name="external-tab"></fcom-icon>
    </a>
  </fcom-notification>
</ng-container>
